module.exports = __webpack_public_path__ + "static/media/App-Store.e355898d.svg";